// Config_DeliveryType
export enum DeliveryType {
    SIDE_BY_SIDE = 1,
    REMOTE,
    TRAINING,
    SELF,
}
